import React from "react";
import QCLogo from "../../assets/images/qc-logo.png";
import marlonPngInitial from "../../images/marlonPngInitial.png";
import { API, graphqlOperation } from "aws-amplify";
import { getCreateOrderOfBilling } from "../../graphql/queries";
import VELASCOMichael from "../../images/Michael_V_Velazco_OIC_ZAU.png";
import JenConception from "../../images/engrJenConception.png";
import JOSEEDGARDOGOMEZ from "../../images/Jose_Edgardo_Gomez_JR.png";
import Hermilia_Campos_Banayat from "../../images/Hermilia_Campos_Banayat.png";

import "./COEForm.scss";

const url = new URL(window.location.href);
const this_id = url.searchParams.get("id");

class ComponentToPrint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      applicationNo: "",
      projectActivity: "",
      lc_No: "",
      lotno: "",
      blkno: "",
      locationstreet: "",
      locationbarangay: "",
      locationdistrict: "",
      zoneclassification: "",
      owner: "",
      lot_area: "",
      floor_area: "",
      noofunits: "",
      tctno: "",
      evaluationfacts: "",
      evaluation_facts_extended: "",
      application_zone: [],
      dataArchitectural: {},
      dataZoning: {},
      dataActualInspection: {},
      user: {},
      project_name: "",
      nothingFollows: "",
      image: "",
      signedImage: "",
      blankWhiteImage: "",
      isBlankImage: false,
      checklistId: null,
      qcUserId: null,
      lc_number: null,
      datePaid: "",
      finalPaymentAmount: 0,
      OrNumber: "",
      OrDate: "",
      grandTotal: "",
      signatureDate2: "",
      postalAddress: "",
      address: "",
      counselResolutionNo: "",
      counselResolutionDate: "",
      approverName: "",
    };
  }

  componentDidMount() {
    try {
      const fetchLocation = async () => {
        const result = await API.graphql(
          graphqlOperation(getCreateOrderOfBilling, { id: this_id })
        );

        this.setState((prev) => {
          const newState = { ...prev };
          const {
            application_no,
            project_activity,
            lcNo,
            lot_no,
            blk_no,
            location_street,
            location_barangay,
            location_district,
            zone_classification,
            owner,
            lot_area,
            floor_area,
            no_of_units,
            tct_no,
            evaluation_facts,
            evaluation_facts_extended,
            OrNumber,
            OrDate,
            grandTotal,
            signatureDate2,
            postalAddress,
            address,
            ceNo,
            counselResolutionNo,
            counselResolutionDate,
            status,
            nameofapprover5,
          } = result.data.getCreateOrderOfBilling;
          let newdate = new Date(counselResolutionDate)
            .toISOString()
            .substring(0, 10);
          let convertDate = new Date(newdate).toLocaleString("en-us", {
            month: "long",
            day: "numeric",
            year: "numeric",
          });
          newState.applicationNo = application_no;
          newState.projectActivity = project_activity;
          newState.lc_No = lcNo;
          newState.lotno = lot_no;
          newState.blkno = blk_no;
          newState.locationstreet = location_street;
          newState.locationbarangay = location_barangay;
          newState.locationdistrict = location_district;
          newState.zoneclassification = zone_classification;
          newState.lotarea = lot_area;
          newState.owner = owner;
          newState.floorarea = floor_area;
          newState.noofunits = no_of_units;
          newState.tctno = tct_no;
          newState.evaluationfacts = evaluation_facts;
          newState.evaluation_facts_extended = evaluation_facts_extended;
          newState.OrNumber = OrNumber;
          newState.OrDate = OrDate;
          newState.grandTotal = grandTotal;
          newState.signatureDate2 = signatureDate2;
          newState.postalAddress = postalAddress;
          newState.address = address;
          newState.ceNo = ceNo;
          newState.counselResolutionDate = convertDate ? convertDate : "";
          newState.counselResolutionNo = counselResolutionNo;
          newState.status = status;
          newState.approverName = nameofapprover5;
          return newState;
        });
      };
      fetchLocation();
    } catch (error) {
      console.log(error);
    }
  }

  downloadThis() {
    document.getElementById("printOption").style.visibility = "hidden";
    document.getElementById("divToPrint").style.marginTop = "-30px";
    window.print();
    document.getElementById("printOption").style.visibility = "visible";
    document.getElementById("divToPrint").style.marginTop = "30px";
  }

  render() {
    let {
      applicationNo,
      projectActivity,
      ceNo,
      lotarea,
      owner,
      floorarea,
      OrNumber,
      OrDate,
      signatureDate2,
      signedImage,
      blankWhiteImage,
      isBlankImage,
      postalAddress,
      address,
      counselResolutionDate,
      counselResolutionNo,
      evaluation_facts_extended,
      grandTotal,
      status,
      approverName,
    } = this.state;

    return (
      <>
        <div className="container-fluid noprint hidden-print" id="printOption">
          <div className="row">
            <button
              onClick={this.downloadThis}
              className="btn btn-primary btn-block"
            >
              Print
            </button>
          </div>
        </div>

        {/* Main Printable */}
        <div className="container-fluid COE" id="divToPrint">
          {/* Header */}
          <header className="row d-flex position-relative">
            <div className="col">
              <img className="qc-logo" src={QCLogo} alt="qc-logo" />

              <div className="row">
                <div className="col text-center">
                  <h6>Republic of the Philippines</h6>
                  <h6>QUEZON CITY</h6>

                  <h5 className="mb-0">CITY PLANNING AND DEVELOPMENT OFFICE</h5>
                  <h6>ZONING ADMINISTRATION UNIT</h6>

                  <h5 className="mb-0">LOCATIONAL CLEARANCE</h5>
                  <h5 className="mb-0">WITH</h5>
                  <h5 className="">CERTIFICATE OF EXCEPTION</h5>

                  <h5 className="fw-bolder">CE No. {ceNo}</h5>
                </div>
              </div>
            </div>
          </header>

          {/* Main */}
          <main className="fw-bold">
            {/* Application Info */}
            <section className="mb-2">
              <div className="row">
                <div className="col">
                  <span>Application No:</span>
                  <span className="ml-3 border-bottom">
                    {applicationNo ? applicationNo : ""}
                  </span>
                </div>

                <div className="col text-right">
                  <span>Date Issued:</span>
                  <span className="ml-3 border-bottom">
                    {applicationNo &&
                      signatureDate2 &&
                      new Date(signatureDate2).toLocaleDateString("en-us", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                  </span>
                </div>
              </div>
            </section>

            {/* Project Info */}
            <section className="px-3">
              <div className="row border">
                <div className="col">
                  {/* Project Activity */}
                  <div className="row">
                    <div className="col">
                      <span>Project Activity:</span>
                    </div>
                  </div>
                  <div className="row border-bottom">
                    <div className="col text-center">
                      <h5 className="px-5">
                        {projectActivity ? projectActivity?.toUpperCase() : ""}
                      </h5>
                    </div>
                  </div>

                  {/* Location */}
                  <div className="row">
                    <div className="col">
                      <span>Location:</span>
                    </div>
                  </div>
                  <div className="row border-bottom">
                    <div className="col text-center">
                      <h5 className="px-5">{address}</h5>
                    </div>
                  </div>

                  {/* Lot & Floor Area */}
                  <div className="row border-bottom px-3">
                    <div className="col border-right pl-3">
                      <div className="row">
                        <div className="col pl-0 ml-0">
                          <span>Lot Area (sq.m.):</span>
                        </div>
                        <div className="col">
                          {/* <span>{lotarea && Number(lotarea).toFixed(2)}</span> */}
                          <span>
                            {lotarea &&
                              lotarea
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="row">
                        <div className="col">
                          <span>Floor Area (sq.m.):</span>
                        </div>
                        <div className="col">
                          {/* <span>{floorarea && Number(floorarea).toFixed(2)}</span> */}
                          <span>
                            {floorarea &&
                              floorarea
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Owner */}
                  <div className="row">
                    <div className="col">
                      <span>Owner:</span>
                    </div>
                  </div>
                  <div className="row border-bottom">
                    <div className="col text-center">
                      <h5 className="px-5">{owner && owner.toUpperCase()}</h5>
                    </div>
                  </div>

                  {/* Post Address */}
                  <div className="row">
                    <div className="col">
                      <span>Postal Address:</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-center">
                      <h5 className="px-5">
                        {postalAddress ? postalAddress?.toUpperCase() : ""}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Issuance Note */}
            <section className="mb-3">
              <div className="row mx-5">
                <div className="col text-center">
                  <span>
                    <i>
                      This Certificate of Exception is being issued to{" "}
                      <b>{owner && owner.toUpperCase()}</b> pursuant to the City
                      Council Resolution No. <b>{counselResolutionNo}</b> dated{" "}
                      <b>{counselResolutionDate}</b> subject to compliance with
                      the following conditions.
                    </i>
                  </span>
                </div>
              </div>
            </section>

            {/* Conditions */}
            <section>
              <div className="row">
                <div className="col">
                  <ol>
                    <li>
                      That this Clearance shall be posted in a conspicuous place
                      within the premises/building during construction and after
                      occupancy.
                    </li>
                    <li>
                      That the proponent cannot undertake any activity other
                      than those applied for without the approval, from this
                      Office.
                    </li>
                    <li>
                      That no additional activity/project floor area other than
                      indicated in this Certificate shall be made/utilized
                      without prior approval from this Office.
                    </li>
                    <li>
                      That any material falsehood or misinterpretation in the
                      submitted documents made in connection with this
                      certificate shall render this Null and Void.
                    </li>
                    <li>
                      That this implementation of the project shall commence
                      within a period of one-year from the date of issuance of
                      this Certificate, otherwise the proponent shall re-apply
                      for a new Certificate.
                    </li>
                    <li>
                      That this office reserves the right to inspect and review
                      said project/operation and should there be any violation
                      found, to institute cancellation proceedings.
                    </li>
                    <li>
                      That any violation of these conditions will mean the
                      suspension or cancellation/revocation of this Clearance,
                      subject to legal action (criminal and/or administrative)
                      as applicable under local and national laws.
                    </li>
                    <li>
                      That the proponent shall secure permits/clearances
                      required by other pertinent laws and regulations.
                    </li>
                    <li>
                      That this Certificate can be revoked in the interest of
                      the general public.
                    </li>
                    <li>
                      That the proponent shall comply with the provisions of the{" "}
                      <b>Green Building Ordinance SP-1917, S-2009</b> and{" "}
                      <b>Green Roof Ordinance SP-1940, S-2009</b>.
                    </li>
                    <li>
                      That the proponent shall comply with{" "}
                      <b>Accessibility Law, BP344</b>.
                    </li>
                    <li>
                      That the proponent shall comply with{" "}
                      <b>RA 9994 (Expanded Senior Citizen Act of 2010)</b>.
                    </li>
                    <li>
                      That the proponent shall preserve natural
                      countour/topography of the area.
                    </li>
                    <li>
                      That the project shall be provided with whole strobe
                      beacon light on the topmost part of the building and
                      iconic street furniture/markers.
                    </li>
                    <li>
                      That the proponent shall beautify the area fronting{" "}
                      {address} (in reference to resolution No.{" "}
                      {counselResolutionNo}).
                    </li>
                    <li>
                      That all conditions stipulated herein from part of this
                      Locational Clearance and are subject to monitoring.
                    </li>
                  </ol>
                </div>
              </div>
            </section>

            {/* Nothing Follows */}
            <section className="mb-3">
              <div className="row">
                <div className="col text-center">"nothing follows"</div>
              </div>
            </section>
            {evaluation_facts_extended && applicationNo !== "BA2406-01182" && (
              <section className="mb">
                <div className="row">
                  <div
                    className="col text-left"
                    style={{ marginLeft: "400px" }}
                  >
                    Additional Condition
                  </div>
                </div>
              </section>
            )}

            {/* Signature */}
            <section className="mb-3">
              <div className="row">
                <div className="col pl-5">
                  <div className="row mb-1">
                    <div className="box mx-5"></div>
                  </div>
                  <div className="row">
                    <small
                      className="mx-4"
                      style={{ fontSize: "16px", fontWeight: "bold" }}
                    >
                      NOT VALID WITHOUT SEAL
                    </small>
                  </div>
                </div>
                <div className="col pl-5">
                  <div className="row mb-1">
                    <div className="box1 mx-5"></div>
                  </div>
                  <div className="row">
                    <small className="mx-4">
                      {evaluation_facts_extended && applicationNo !== "BA2406-01182" && (
                        <div style={{ marginLeft: -200, marginTop: -100 }}>
                          <div
                            className="empty-box1 p-1"
                            style={{ fontSize: "16px", fontWeight: "bold" }}
                          >
                            <p>
                              {evaluation_facts_extended.toLocaleUpperCase()}
                            </p>
                          </div>
                        </div>
                      )}
                    </small>
                  </div>
                </div>
                <div className="col text-right pr-5">
                  <div className="row" style={{ marginTop: 24 }}>
                    <div className="col text-center">
                      {isBlankImage === true ? (
                        <>
                          <img
                            src={signedImage}
                            className="img-fluid visible-no-print"
                            alt="blank"
                          />
                          <img
                            src={blankWhiteImage}
                            className="img-fluid visible-print"
                            alt="blank"
                          />
                        </>
                      ) : (
                        <img
                          src={
                          approverName === "Michael B Velasco"
                            ? VELASCOMichael
                            : approverName === "Jose Edgardo A Gomez, JR"
                              ? JOSEEDGARDOGOMEZ
                              : approverName === "Hermilia Campos Banayat"
                                ? Hermilia_Campos_Banayat
                                : JenConception
                        }
                          width={approverName === "Jose Edgardo A Gomez, JR" ? "350px" : approverName === "Hermilia Campos Banayat" ? "200px" : "200px"}
                          className="img-fluid img-custom"
                          alt="blank"
                          style={
                            approverName === "Jose Edgardo A Gomez, JR"
                              ? {}
                              : approverName === "Hermilia Campos Banayat"
                                ? {
                                    transform: "rotate(370deg)",
                                    position: "relative",
                                    top: 15,
                                  }
                                : { transform: "rotate(370deg)" }
                          }
                        />
                      )}
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: 16 }}>
                    <div className="col text-center">
                      <span>
                        {" "}
                        {approverName === "Michael B Velasco"
                      ? "MR. MICHAEL B. VELASCO"
                      : approverName === "Jose Edgardo A Gomez, JR"
                        ? "DR. JOSE EDGARDO A GOMEZ, JR."
                        : approverName === "Hermilia Campos Banayat"
                          ? "HERMILIA CAMPOS BANAYAT"
                          : "JENNIFER G. CONCEPCION"}
                      </span>
                      <span>
                        <img
                          src={marlonPngInitial}
                          width="50"
                          height="50"
                          alt=""
                        />
                      </span>
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: 4 }}>
                    <div className="col text-center">
                      <span>
                        {approverName === "Hermilia Campos Banayat"
                          ? "Secretary to the Mayor, Office of the Secretary to the Mayor,"
                          : "OIC - ZONING ADMINISTRATION UNIT"}
                      </span>
                    </div>
                  </div>
                  {approverName === "Hermilia Campos Banayat" && (
                    <div className="row" style={{ marginTop: 2 }}>
                      <div className="col text-center">
                        <span>Officer-in-Charge, Zoning Administration Unit</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>

            {/* OR Number & Date Paid */}
            <section>
              <div className="row">
                <span className="mw-100">OR No:</span>
                <span className="ml-3 border-bottom">
                  {OrNumber && OrNumber !== "0" ? OrNumber : ""}
                </span>
              </div>
              <div className="row">
                <span className="mw-100">Date Paid:</span>
                <span className="ml-3 border-bottom">
                  {OrDate && OrDate !== "0" ? OrDate : ""}
                </span>
              </div>
              <div className="row">
                <span className="mw-100">Amount Paid:</span>
                <span className="ml-3 border-bottom">
                  {status === "5"
                    ? grandTotal &&
                      "₱" +
                        new Intl.NumberFormat("en-US", {
                          style: "decimal",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(grandTotal)
                    : ""}
                </span>
              </div>
            </section>
          </main>
        </div>
      </>
    );
  }
}

export default ComponentToPrint;
